import { URL } from '../helpers/PushNotificationsEndpoint';
import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';

const PushNotificationsService = {

    async checkPushNotificationPreference (user) {
        const { result } = await AuthenticatedAPIClient.get(URL.pushNotifications.replace('{id}', user.id));
        return result;
    }

};

export default PushNotificationsService;



// WEBPACK FOOTER //
// ./src/services/PushNotificationsService.js